<template>
  <a-card size="small" title="其他指标">
    <div class="wrapper" v-for="(item, index) of list" :key="index">
      <div class="item" v-for="(item2, index2) in item" :key="`${index}-${index2}`">
        <div class="label">{{item2.label}}:</div>
        <div class="value">{{item2.value}}</div>
      </div>
    </div>
  </a-card>
</template>

<script>
import * as R from 'ramda'

export default {
  name: 'OtherChart',
  props: {
    data: Object,
  },
  computed: {
    list () {
      const listMap = {}
      const keys = Object.keys(this.data).filter(key => R.is(Number, this.data[key]))
      keys.forEach(key => {
        listMap[key[0]] = [...(listMap[key[0]] || []), { label: key, value: this.data[key] }]
      })
      return listMap
    },
  },
}
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  .item {
    width: 33.33%;
    display: flex;
    .label {
      margin-right: 10px;
      // font-weight: bold;
    }
  }
}
.wrapper:last-child {
  border: none;
}
</style>
